<lib-page-layout>
  <lib-title-navbar
    pageHeader
    [showBackArrow]="true"
    title="Ranking - Top 50"
    [showRankQAIcon]="true"
    (onRankQAClicked)="goToRankQA()"></lib-title-navbar>

  <div class="or-p-16-px">
    @for (user of topRank()?.users; track user.rank; let i = $index, first = $first) {
      <div class="or-d-flex or-justify-content-between or-align-items-center or-mb-12-px" [class.or-mt-16-px]="!first">
        <div class="or-d-flex or-align-items-center">
          <div class="or-head-sm or-color-secondary-2 or-mr-8-px">{{ i + 1 }}</div>
          <lib-or-avatar
            [avatarUrl]="user.thumbnail"
            [initials]="user.displayName"
            [avatarSize]="'sm'"
            [rightMargin]="false"
            class="or-mr-8-px"></lib-or-avatar>
          <div class="or-head-sm">{{ user.displayName }}</div>
        </div>
        <div class="or-head-sm">{{ user.points }}</div>
      </div>
      <div class="custom-divider or-w-100-pc"></div>
    }
  </div>

  <lib-bottom-navbar pageFooter></lib-bottom-navbar>
</lib-page-layout>
